import axios from 'axios';
import endpointUrls from 'global/Constants/endpointUrls';

const env = process.env;

export const mapIrGetAddressFromLatLng = async (lat: number, lng: number) => {
  return await axios
    .get(endpointUrls.MapIrGetAddressFast(lat, lng), { headers: { 'x-api-key': mapIrToken() } })
    .then((res: any) => {
      return res.data;
    })
    .catch(() => {});
};

export const mapIrToken = (): any => {
  // const envName = env.REACT_APP_NOD_ENV;

  switch (env as any) {
    case 'local':
      return env.REACT_APP_LOCAL_MAP_IR_TOKEN || '';
    case 'development':
      return env.REACT_APP_DEVELOPMENT_MAP_IR_TOKEN || '';
    case 'staging':
      return env.REACT_APP_STAGING_MAP_IR_TOKEN || '';
    case 'production':
      return env.REACT_APP_PRODUCTION_MAP_IR_TOKEN || '';
    default:
      return '';
  }
};
